import Vue from 'vue';
import select from 'dom-select';
import { isTablet } from 'utils/general';
import { trackEvent } from '../../assets/js/lib/tracking';
import { Autoplay, Navigation, A11y, Keyboard } from "swiper/modules";

export default (el) => new Vue({
  components: {
    'vue-swiper': () => import('../vue-swiper/vue-swiper.vue')
  },
  el,
  data() {
    return {
      isTablet: isTablet(),
      swiperInstance: null,
      swiper: this.$refs,
      isPaused: false,
      accountBtns: this.$el?.querySelectorAll(".js-content a"),
      swiperOptions: {
        slidesPerView: 1,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        a11y: {
          slideLabelMessage: 'Slide {{index}} of {{slidesLength}}',
        },
        keyboard: true,
        autoplay: el.dataset.speed > 0 ? { delay: el.dataset.speed * 1000 } : false,
        modules: [Autoplay, Navigation, A11y, Keyboard],
        on: {
          init: (swiper) => {
            this.swiperInstance = swiper;
            this.setAriaHidden(swiper)
          },
          slideChange: this.setAriaHidden
        }
      },
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.initializeAccountButtons();
    });
  },
  methods: {
    setAriaHidden(swiper) {
      swiper.slides.forEach(slide => {
        const visible = slide.classList.contains('swiper-slide-active');
        slide.setAttribute('aria-hidden', String(!visible));
        slide.tabIndex = visible ? 0 : -1;
      });
    },
    initializeAccountButtons() {
      const el = this.$el;
      const accountBtns = select.all('.js-content a', el.swiper);
      if (accountBtns) {
        accountBtns.forEach(btn => {
          btn.addEventListener('click', (e) => {
            const aTag = e.target.closest('a');
            if (aTag.title === 'login') {
              trackEvent({
                event: 'login_start',
                component_name: 'announcement banner',
                module_name: 'unlock free shipping',
                shopify_module_name: 'promo bar'
              });
            } else if (aTag.title === 'register') {
              trackEvent({
                event: 'sign_up_start',
                component_name: 'announcement banner',
                module_name: 'unlock free shipping',
                shopify_module_name: 'promo bar'
              });
            }
          });
        });
      }
    },
    handlePauseClick() {
      const swiper = this.swiperInstance;
      if (this.isPaused) {
        swiper.autoplay.start();
      } else {
        swiper.autoplay.stop();
      }
      this.isPaused = !this.isPaused;
    },
  }
});
